const isWorkFetching = state => state.WorkDetailsStore.loading
const isWorkBeingUpdated = state =>
  state.WorkDetailsStore.workBeingUpdated || false
const getWork = state => state.WorkDetailsStore.work
const getMedia = (state, id) =>
  getWork(state).media.filter(medium => medium.id === id)[0]
const getMediaCount = (state, id) => getWork(state).media.length

export { isWorkFetching, isWorkBeingUpdated, getWork, getMedia, getMediaCount }
